import axios from "axios";
import { apiEndpoint, apiEndpointFunction } from '@iso/lib/helpers/endpoint';
import { authHeader } from '@iso/lib/helpers/authHeader';

export const primaryObjectService = {
  getList,
  storeOrUpdateProperties,
  destroy,
  updateArea,
  getListPaging,
  view,
  getListNearest,
};

function getList(propertyId){
  return (
    axios
      .get(
        `${apiEndpoint.primaryObjects}?property_id=${propertyId}`,
        {
          headers: authHeader(),
        }
      ).then(res => {
        if(res && res.status === 200 && res.data.code === '0000'){
          return res.data;
        }
      })
  );
}

function getListPaging(propertyId,page,pageSize){
  return (
    axios
      .get(
        `${apiEndpoint.primaryObjects}/area-paging?property_id=${propertyId}&page=${page}&page_size=${pageSize}`,
        {
          headers: authHeader(),
        }
      ).then(res => {
        if(res && res.status === 200 && res.data.code === '0000'){
          return res.data;
        }
      })
  );
}

function storeOrUpdateProperties(data, id = null){
  return (id ? (
    axios
      .put(
        apiEndpointFunction.primaryObjects(id),
        data,
        {
          headers: authHeader(),
        }
      )
  ) : (
    axios
      .post(
        apiEndpoint.primaryObjects,
        data,
        {
          headers: authHeader()
        }
      )
  )).then(res => {
    if(res && res.status === 200){
      return res.data;
    }
    return {};
  });
}

function updateArea(data, id = null){
  return (
    axios
      .put(
        `${apiEndpointFunction.primaryObjects(id)}/update-area`,
        data,
        {
          headers: authHeader()
        }
      ).then(res => {
        if(res && res.status === 200){
          return res.data;
        }
      })
  );
}

function destroy(id){
  return (
    axios
      .delete(
        apiEndpointFunction.primaryObjects(id),
        {
          headers: authHeader()
        }
      ).then(res => {
        if(res && res.status === 200){
          return res.data;
        }
      })
  );
}

function view(id){
 return (
    axios
      .get(
        apiEndpointFunction.primaryObjects(id),
        {
          headers: authHeader()
        }
      ).then(res => {
        if(res && res.status === 200){
          return res.data;
        }
      })
  );
}

function getListNearest(propertyId,lat,lng,mobId){
   return (
    axios
      .get(
        `${apiEndpoint.primaryObjects}/get-list-nearest?property_id=${propertyId}&lat=${lat}&lng=${lng}&mob_id=${mobId}`,
        {
          headers: authHeader(),
        }
      ).then(res => {
        if(res && res.status === 200 ){
          return res.data;
        }
      })
  );

}